export default __webpack_public_path__ + "static/media/AE.b9fa9036.svg";